import React, { useContext } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { FormOptions } from '../../../../constants/form';
import { FormModal } from '../../../../components/containers/FormModal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { SubmitHandler } from 'react-hook-form/dist/types/form';
import { BoxNotification } from '../../../../components/containers/BoxNotification';
import { BeaconContext } from '../../../../providers/BeaconProvider';

export type BulkDeleteTimeslotsModalViewProps = {
  onClose: () => void;
  deleteTimeslotHandler: SubmitHandler<FieldValues>;
  submitted: boolean;
};

export const BulkDeleteTimeslotsModalView = (props: BulkDeleteTimeslotsModalViewProps): JSX.Element => {
  const useFormInstance = useForm(FormOptions);
  const { beacon } = useContext(BeaconContext);

  return (
    <FormModal
      onClose={props.onClose}
      showCloseIcon={true}
      formInstance={useFormInstance}
      loading={props.submitted}
      onSubmit={props.deleteTimeslotHandler}
      submitText={'Delete Timeslots'}
      primaryButtonColor={ButtonColorsEnum.alert}
      primaryButtonDisabled={props.submitted}
      title={'Confirm Deletion'}>
      <p>
        This will delete all currently visible Timeslots. Any active queued Posts that rely on these Timeslots will not
        be published, but will be kept in the Unqueued filter in your Queue.{' '}
        <a onClick={() => beacon('article', '697', { type: 'modal' })}>Learn more</a>
      </p>
      <BoxNotification type={'error'}>This action cannot be undone.</BoxNotification>
    </FormModal>
  );
};
